import { useState } from "react";
import { Button } from "react-bootstrap";
import PopUpModal from "../Modal";
import * as postapi from "../../api/postapi";
import useApi from "../../Hooks/useApi";
import { toast } from "react-toastify";
import { RiDraftLine, RiEraserLine } from "react-icons/ri";
import styles from "./OrdersWorkspace/OrdersWorkspace.module.css";

const ToggleDummyModal = ({ show, data, onHide, toggle, mode = "mark" }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [error, setError] = useState("");
  const markAsDummyCall = useApi(postapi.markAsDummy, { hasCatchError: true });
  const unmarkDummyCall = useApi(postapi.unmarkDummy, { hasCatchError: true });

  const close = () => {
    setIsClicked(false);
    onHide();
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsClicked(true);
      const response = mode === "unmark"
        ? await unmarkDummyCall.request(data.id)
        : await markAsDummyCall.request(data.id);
      if (response.status === 200) {
        toast.success(response?.data?.message, {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        close();
        toggle();
      }
    } catch (error) {
      setError(error.response?.data?.error?.message || "Something went wrong");
      setIsClicked(false);
    }
  };

  const isUnmark = mode === "unmark";

  return (
    <PopUpModal
      title={isUnmark ? "Remove Dummy Status" : "Mark as Dummy"}
      show={show}
      onHide={close}
      closeButton={false}
    >
      <>
        {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}
        <div>
          <span className="d-flex justify-content-center pb-3 text-center">
            {isUnmark
              ? "Remove the dummy flag from this order? It will be included in default listings and dashboard insights again."
              : "Mark this order as dummy? It will be excluded from default listings and dashboard insights, but remain in the database."}
          </span>
        </div>
        <div className={styles.modalActions}>
          <Button className={styles.modalAction} variant="outline-secondary" onClick={close}>
            Cancel
          </Button>
          <Button
            className={styles.modalAction}
            variant={isUnmark ? "warning" : "primary"}
            onClick={handleSubmit}
            disabled={isClicked}
          >
            {isUnmark ? <><RiEraserLine aria-hidden="true" /> Remove Dummy</> : <><RiDraftLine aria-hidden="true" /> Mark as Dummy</>}
          </Button>
        </div>
      </>
    </PopUpModal>
  );
};

export default ToggleDummyModal;
